import React from 'react'
import PropTypes from 'prop-types'
import { history } from 'store/store'
import { Button, buttonPropTypes } from '.'

const LinkButton = (props) => {
  const { title, href, children, ...otherProps } = props
  return (<Button title={title} onClick={() => history.push(href)} {...otherProps}>{children}</Button>)
}

LinkButton.propTypes = {
  ...buttonPropTypes,
  href: PropTypes.string,
  title: PropTypes.string
}
LinkButton.defaultProps = {
  width: 150,
  marginLeft: 0,
  marginRight: 0,
  size: 'medium',
  isLoading: false,
  href: '/',
  uppercase: false,
  variant: 'text',
  color: 'default'
}

export default LinkButton
